import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2';
import './TabbedProjectComponent.css'


const UpdateProjectModal = ({ project, onSave, onClose }) => {
  
  const [formData, setFormData] = useState({});

  useEffect(() => {
    setFormData({
      ...project,
      links: {
        ...project.links,
        details: {
          ...project.links.details,
          titleSmall: project.links.details.titleSmall || '',
          titleBig: project.links.details.titleBig || '',
          desc: project.links.details.desc || '',
          client: project.links.details.client || '',
          server: project.links.details.server || '',
        },
      },
    });
  }, [project]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    // Handle category field separately
    if (name === 'category') {
      setFormData((prevData) => ({
        ...prevData,
        category: value.split(','),
      }));
      return;
    }

    setFormData((prevData) => {
      const nestedFieldNames = name.split('.');
      const updatedData = { ...prevData };
      let currentField = updatedData;

      for (let i = 0; i < nestedFieldNames.length - 1; i++) {
        const fieldName = nestedFieldNames[i];
        currentField[fieldName] = currentField[fieldName] || {};
        currentField = currentField[fieldName];
      }

      const finalFieldName = nestedFieldNames[nestedFieldNames.length - 1];
      currentField[finalFieldName] = value;

      return updatedData;
    });
  };

  const handleSaveClick = () => {
    Swal.fire({
      title: 'Do you want to save the changes?',
      showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: 'Save',
      denyButtonText: `Don't save`,
      confirmButtonColor: "#DF7E07",
      customClass: {
        confirmButton: 'swal2-confirm', // Add this line
        denyButton: 'swal2-deny', // Add this line
        cancelButton: 'swal2-cancel', // Add this line
      },
    }).then((result) => {
      if (result.isConfirmed) {
        const updatedData = {
          ...formData,
          links: {
            ...formData.links,
            image: formData.links?.image || formData.links.image,
            bannerImg: formData.links?.bannerImg || formData.links.bannerImg,
            details: {
              ...formData.links.details,
              titleSmall:
                formData.links?.details?.titleSmall || formData.links.details.titleSmall,
              titleBig:
                formData.links?.details?.titleBig || formData.links.details.titleBig,
              desc: formData.links?.details?.desc || formData.links.details.desc,
              client: formData.links?.details?.client || formData.links.details.client,
              server: formData.links?.details?.server || formData.links.details.server,
            },
          },
          category: Array.isArray(formData.category) ? formData.category : [],
          priority: formData.priority || 0,
          slide: {
            ...formData.slide,
            img1: formData.slide?.img1 || formData.slide.img1,
            img2: formData.slide?.img2 || formData.slide.img2,
            img3: formData.slide?.img3 || formData.slide.img3,
            img4: formData.slide?.img4 || formData.slide.img4,
          },
          // Add other fields here
        };
        onSave(updatedData);
        Swal.fire('Saved!', '', 'success');
      } else if (result.isDenied) {
        Swal.fire('Changes are not saved', '', 'info');
      }
    });
  };

  const handleCloseClick = () => {
    Swal.fire({
      title: 'Do you want to close without saving?',
      showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: 'Close',
      denyButtonText: 'Save and Close',
      
    }).then((result) => {
      if (result.isConfirmed) {
        onClose();
      } else if (result.isDenied) {
        handleSaveClick();
        onClose();
      }
    });
  };

  return (
    <div className="flex flex-wrap" style={{ height: '470px', overflowY: 'auto' }}>
    {/* First Column */}
    <div className="w-full md:w-1/2 p-4">
      <label className="block mb-2">
        Image:
        <input
          type="text"
          name="links.image"
          placeholder="Image URL"
          value={formData.links?.image || ''}
          onChange={handleInputChange}
          className="w-full py-2 px-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
      </label>
      <label className="block mb-2">
        Banner Image:
        <input
          type="text"
          name="links.bannerImg"
          placeholder="Banner Image URL"
          value={formData.links?.bannerImg || ''}
          onChange={handleInputChange}
          className="w-full py-2 px-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
      </label>
      <label className="block mb-2">
        Small Title:
        <input
          type="text"
          name="links.details.titleSmall"
          placeholder="Small Title"
          value={formData.links?.details?.titleSmall || ''}
          onChange={handleInputChange}
          className="w-full py-2 px-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
      </label>
      <label className="block mb-2">
        Description:
        <textarea
          name="links.details.desc"
          placeholder="Description"
          value={formData.links?.details?.desc || ''}
          onChange={handleInputChange}
          className="w-full py-2 px-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
        ></textarea>
      </label>
      <label className="block mb-2">
        Server URL:
        <input
          type="text"
          name="links.details.server"
          placeholder="Server URL"
          value={formData.links?.details?.server || ''}
          onChange={handleInputChange}
          className="w-full py-2 px-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
      </label>
      <label className="block mb-2">
        Date:
        <input
          type="text"
          name="date"
          placeholder="Date"
          value={formData.date || ''}
          onChange={handleInputChange}
          className="w-full py-2 px-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
      </label>
      <label className="block mb-2">
        Slide Image 1:
        <input
          type="text"
          name="slide.img1"
          placeholder="Image 1 URL"
          value={formData.slide?.img1 || ''}
          onChange={handleInputChange}
          className="w-full py-2 px-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
      </label>
      <label className="block mb-2">
        Slide Image 3:
        <input
          type="text"
          name="slide.img3"
          placeholder="Image 3 URL"
          value={formData.slide?.img3 || ''}
          onChange={handleInputChange}
          className="w-full py-2 px-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
      </label>
    </div>

    {/* Second Column */}
    <div className="w-full md:w-1/2 p-4">
      <label className="block mb-2">
        Live Link:
        <input
          type="text"
          name="links.live"
          placeholder="Live Link"
          value={formData.links?.live || ''}
          onChange={handleInputChange}
          className="w-full py-2 px-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
      </label>
      <label className="block mb-2">
        Big Title:
        <input
          type="text"
          name="links.details.titleBig"
          placeholder="Big Title"
          value={formData.links?.details?.titleBig || ''}
          onChange={handleInputChange}
          className="w-full py-2 px-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
      </label>
      <label className="block mb-2">
        Client URL:
        <input
          type="text"
          name="links.details.client"
          placeholder="Client URL"
          value={formData.links?.details?.client || ''}
          onChange={handleInputChange}
          className="w-full py-2 px-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
      </label>
      <label className="block mb-2">
        Category:
        <input
          type="text"
          name="category"
          placeholder="Category"
          value={Array.isArray(formData.category) ? formData.category.join(', ') : ''}
          onChange={handleInputChange}
          className="w-full py-2 px-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
      </label>
      <label className="block mb-2">
        Priority:
        <input
          type="number"
          name="priority"
          placeholder="Priority"
          value={formData.priority || ''}
          onChange={handleInputChange}
          className="w-full py-2 px-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
      </label>
      <label className="block mb-2">
        Slide Image 2:
        <input
          type="text"
          name="slide.img2"
          placeholder="Image 2 URL"
          value={formData.slide?.img2 || ''}
          onChange={handleInputChange}
          className="w-full py-2 px-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
      </label>
      <label className="block mb-2">
        Slide Image 4:
        <input
          type="text"
          name="slide.img4"
          placeholder="Image 4 URL"
          value={formData.slide?.img4 || ''}
          onChange={handleInputChange}
          className="w-full py-2 px-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
      </label>
    </div>

    {/* Save and Close buttons */}
    <div className="w-full p-4">
        <button
          onClick={handleSaveClick}
          className="w-full md:w-auto px-4 py-2 bg-[#ffa201e0] text-white rounded-md hover:bg-warning focus:outline-none"
        >
          Save
        </button>
        <button
          onClick={handleCloseClick}
          className="w-full md:w-auto mt-2 md:mt-0 md:ml-2 px-4 py-2 bg-gray-300 text-gray-800 rounded-md hover:bg-gray-400 focus:outline-none"
        >
          Close
        </button>
      </div>
  </div>
  );
};

export default UpdateProjectModal;
